<template>
  <div class="profile-page" dir="rtl">
    <div class="profile-layout">
      <div class="form-panel">
        <div class="login-card-outer">
          <div class="form-grid">
            <div>
              <div class="input-group" :data-label="$t('insertMobileNo')">
                <img class="input-icon" src="/img/smartphone.svg" alt="mobile" />
                <input
                  v-model="user_mobile"
                  class="input"
                  type="tel"
                  placeholder="09123456789"
                  style="text-align: right;"
                />
              </div>
            </div>
          </div>

          <div class="actions">
            <button class="btn primary" @click="send_sms()">{{ $t('sendCode') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    data () {
      return {
        user_mobile :'',
        user_name :'',
        user_code :'',

        error: []
      }
    },
    mounted () {
      this.profile()
    },
    methods: {
      profile () {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        this.user_name = user_data.UserName
        this.user_code = user_data.UserCode
        this.user_id = user_data.UserId
        console.log(JSON.parse(localStorage.getItem('profile')))
        this.user_mobile = localStorage.getItem('phone')
      },
      send_sms () {
        var self = this
        if (this.user_mobile == '' || this.user_mobile == ' ') {
          this.error.push(this.$t('mobileIsEmpty'))
        }
        if (this.user_mobile != '') {
          const send_data = {
            MobileNo:this.user_mobile,
          }
          this.axios.post('/GetNewSms', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                self.$router.push({ name:self.$t('changePassword'), params:{} })
              }
            }).catch(e => {

            })
        }
      }
    }

  }
</script>
<style scoped>
  .profile-page {
    min-height: 100dvh;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 16px;
    background: #f1f5f9;
  }
  .profile-layout { width: 100%; max-width: 512px; }
  .form-panel { width: 100%; display: flex; align-items: flex-start; justify-content: center; padding-top: 20px; }

  .login-card-outer {
    width: 100%;
    background: #ffffff;
    border-radius: 15px;
    border: 0.5px solid rgba(163, 163, 163, 0.747);
    padding: 24px;
    /* box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.06),
      0 8px 16px rgba(0, 0, 0, 0.03); */
    border: 0.5px solid rgba(226, 232, 240, 0.4);
  }

  .form-grid > * + * { margin-top: 16px; }

  /* Input styles are now in global stylesheet */

  .actions { margin-top: 20px; }
  .btn {
    width: 100%;
    height: 56px;
    border: 0;
    border-radius: 15px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  .btn:hover::before { left: 100%; }
  .btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
  .btn:not(:disabled):hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(28, 57, 187, 0.25); }
  .primary { color: #ffffff; background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%); box-shadow: 0 4px 15px rgba(28, 57, 187, 0.2); }
</style>
